import { onBeforeMount, ref } from 'vue'
import NewCarLoanCalculatorInputs from '../Components/NewCarLoanCalculatorInputs/NewCarLoanCalculatorInputs.vue'
import { updateUrlParametersAndReload } from '../Methods/utils'
import { GTMService } from '../../../services/gtm.service.js'
import Loader from '../../../../../Frontend/src/components/Loader/Loader.vue'

export default {
    name: 'NewCarLoanCalculatorInput',
    components: {
        NewCarLoanCalculatorInputs,
        Loader
    },
    props: {
        labelsInput: {
            type: Object,
            required: true,
        },
        labelsLegal: {
            type: Object,
            required: true,
        },
        labelsError: {
            type: Object,
            required: true,
        },
        optionsInput: {
            type: Object,
            required: true,
        },
        systemErrorMessage: {
            type: String,
            required: true,
        }

    },
    setup() {
        const hideSystemErrorMessage = ref(false)
        const isFormValid = ref(null)

        const displayErrors = ref(false)

        const isLoading = ref(false)

        const carPrice = ref('')
        const downPayment = ref('')
        const loanTerm = ref('')

        const onChangeCallback = ((data) => {
            isFormValid.value = data.isFormValid
            carPrice.value = data.carPrice
            downPayment.value = data.downPayment
            loanTerm.value = data.loanTerm
        })

        const submit = function () {
            displayErrors.value = true
            if (isFormValid.value) {
                console.log("Valid form")
                const loadingTimeout = setTimeout(() => {
                    isLoading.value = true
                }, 100)
                displayErrors.value = false

                const mappedUrlParameters = {
                    "cp": carPrice.value,
                    "dp": downPayment.value,
                    "lt": loanTerm.value
                }

                trackCalculation({ carPrice: carPrice.value, carDownpayment: downPayment.value, loanTerm: loanTerm.value });

                updateUrlParametersAndReload(mappedUrlParameters)
            }
        }

        const trackCalculation = (trackingFields) => {
            GTMService.pushToDataLayer([
                {
                    'event': 'track-event.beregn_elbil',
                    'eventCategory': 'beregn',
                    'eventAction': "elbil",
                    'eventLabel': 'submit',
                    'eventNoninteraction': true,
                    ...trackingFields
                },
                {
                    'event': 'track-event.beregn_alle',
                    'eventCategory': 'beregn',
                    'eventAction': "alle",
                    'eventLabel': 'track-event.beregn_elbil beregn_elbil',
                    'eventNoninteraction': true
                },
            ])
        }

        const handleHideSystemErrorMessage = () => {
            hideSystemErrorMessage.value = true
        }

        onBeforeMount(() => {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('cp') || urlParams.has('dp') || urlParams.has('tl') || urlParams.has("isError")) {
                displayErrors.value = true
            }
        })

        return {
            isLoading,
            displayErrors,
            hideSystemErrorMessage,
            submit,
            onChangeCallback,
            handleHideSystemErrorMessage,
        }
    },
}